import { Result, failure, success } from '../shared'
import { PrintReportProvider } from './printReport.provider'
import {
  PrintReportParams,
  PrintReportServerData,
  PrintReportServiceErrorCode,
  PrintReportFailure,
} from './printReport.types'

export class PrintReportService {
  constructor(private provider: PrintReportProvider) {}

  public async get(params: PrintReportParams, body: {}): Promise<Result<PrintReportServerData, PrintReportFailure>> {
    try {
      const { data } = await this.provider.get(params, body)
      return success(data)
    } catch (error) {
      return failure(PrintReportServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
